import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PreviewFile } from '../ImageLibraryModal';

export interface FintueArtstyleModel {
  pricing: {
    personal: number;
    standard: number;
    commercial: number;
  };
  artist: {
    styleName: string,
    pricing: {
      model: 'own' | 'saagas',
      price: number
    }
  }
  name: string;
  images: string[];
}


const initialFintueModel: FintueArtstyleModel = {
  pricing: {
    personal: 2500,
    standard: 5000,
    commercial: 10000
  },
  artist: {
    styleName: '',
    pricing: {
      model: 'own',
      price: 25
    }
  },
  name: '',
  images: []
};

interface FintueArtstyleContextProps {
  fintueModel: FintueArtstyleModel;
  setFintueModel: React.Dispatch<React.SetStateAction<FintueArtstyleModel>>;
  setSelectedImages: React.Dispatch<React.SetStateAction<PreviewFile[]>>;
  selectedImages: PreviewFile[];
}

const FintueArtstyleContext = createContext<FintueArtstyleContextProps>({} as FintueArtstyleContextProps);

export const FintueArtstyleProvider = ({ children }: { children: ReactNode }) => {
  const [fintueModel, setFintueModel] = useState<FintueArtstyleModel>(initialFintueModel);
  const [selectedImages, setSelectedImages] = useState<PreviewFile[]>([]);

  return (
    <FintueArtstyleContext.Provider value={{ fintueModel, setFintueModel, setSelectedImages, selectedImages }}>
      {children}
    </FintueArtstyleContext.Provider>
  );
};

export const useFintueArtstyle = () => {
  const context = useContext(FintueArtstyleContext);
  if (context === undefined) {
    throw new Error('useFintueArtstyle must be used within a FintueArtstyleProvider');
  }
  return context;
};
